import { render, staticRenderFns } from "./PostImageUploader.vue?vue&type=template&id=3c61aade&scoped=true&"
import script from "./PostImageUploader.vue?vue&type=script&lang=js&"
export * from "./PostImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./PostImageUploader.vue?vue&type=style&index=0&id=3c61aade&lang=postcss&scoped=true&"
import style1 from "./PostImageUploader.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c61aade",
  null
  
)

export default component.exports